import { Backdrop as MuiBackdrop, Container, keyframes, Typography, useTheme } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { useStyles } from '../../theme'
import { SpinnerIcon } from '../icons/SpinnerIcon'

export const Backdrop = () => {
  const theme = useTheme()
  const styles = useStyles()
  return (
    <MuiBackdrop
      open={true}
      sx={{
        backgroundColor: alpha(theme.palette.background.default, 0.5),
        zIndex: theme.zIndex.drawer + 1,
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          my: '2rem',
          justifyContent: 'flex-start',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant="h2">Almost there!</Typography>
        <Typography variant="h6">We're getting things ready for you</Typography>
        <SpinnerIcon
          color="primary"
          sx={{
            fontSize: '10rem',
            animation: `${keyframes`
                0% {
                    transform: rotate(-120deg);
                }

                100% {
                    transform: rotate(240deg);
                }
            `} 0.8s ease-in-out infinite`,
          }}
        />
      </Container>
    </MuiBackdrop>
  )
}
